<div class="w-full h-full flex flex-col overflow-hidden bg-[#F4F5F7]">
    <!-- Page Header & Tabs -->
    <div class="px-4 flex-shrink-0 bg-white border-b border-gray-200">
        <div class="flex">
            <button (click)="activeTab.set('MGMT')" class="px-6 py-3 font-semibold transition-colors border-b-2"
                [class]="activeTab() === 'MGMT' ? 'border-indigo-600 text-indigo-700' : 'border-transparent  hover:text-gray-800 hover:border-gray-300'">
                {{ 'BOOKGSTR0001' | translate }}
            </button>
            <button (click)="activeTab.set('HISTORY')" class="px-6 py-3 font-semibold transition-colors border-b-2"
                [class]="activeTab() === 'HISTORY' ? 'border-indigo-600 text-indigo-700' : 'border-transparent  hover:text-gray-800 hover:border-gray-300'">
                {{ 'REVERSTR0002' | translate }}
            </button>
        </div>
    </div>

    <div class="flex-1 w-full h-full min-h-0 bg-gray-100">
        @if (activeTab() === 'MGMT') {
        <div class="flex-1 flex flex-col bg-[#F4F5F7] overflow-hidden h-full">
            <!-- Toolbar Section -->
            <div class="p-2 bg-white flex flex-col gap-2 border-b border-gray-200">
                <div class="flex justify-between gap-4">
                    <div class="flex justify-start gap-4">
                        <div class="flex justify-between gap-4 items-center">
                            <p-datepicker [(ngModel)]="param.SALE_DT" [iconDisplay]="'input'" [showIcon]="true"
                                inputId="icondisplay" class="w-full md:w-40 2xl:w-56" [readonlyInput]="true"
                                [disabled]="isEdit" inputStyleClass="w-full md:w-40 2xl:w-56" dateFormat="yy-mm-dd"
                                (ngModelChange)="getTime()" [locale]="locale" />
                        </div>
                        <div class="flex justify-between items-center gap-4">
                            <p-select [options]="staffList" [(ngModel)]="selectedStaff" optionLabel="useR_NM"
                                optionValue="useR_ID" class="w-full md:w-40 2xl:w-56" filter="true" filterBy="useR_NM"
                                (ngModelChange)="getTime()" />
                        </div>
                        <div class="flex justify-between items-center gap-4">
                            <!-- <input type="text" pInputText class="w-full md:w-40 2xl:w-56"
                                [placeholder]="'BOOKGSTR0009' | translate" [value]="member()?.membeR_NM ?? ''" disabled> -->
                            <div class="relative" (clickOutside)="showNameDropdown.set(false)">
                                <input type="text" [ngModel]="prepaySearchName()" pInputText maxlength="50"
                                    (input)="onMemberNameInput($event)" (ngModelChange)="onNameSearchInput($event)"
                                    (focus)="
                    prepaySearchName() && onNameSearchInput(prepaySearchName())
                  " class="border border-gray-300 px-3 py-1.5 rounded  bg-white w-full md:w-40 2xl:w-56"
                                    [placeholder]="'BOOKGSTR0009' | translate" />
                                @if (showNameDropdown() && filteredMembersName().length > 0) {
                                <div
                                    class="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto z-50 min-w-[300px]">
                                    @for (member of filteredMembersName(); track member.id) {
                                    <div (click)="selectMemberFromNameDropdown(member)"
                                        class="px-3 py-2 hover:bg-indigo-50 cursor-pointer border-b  last:border-b-0">
                                        <div class="flex justify-between items-center">
                                            <div>
                                                <div class="font-bold  text-gray-900">
                                                    {{ member.name }}
                                                </div>
                                                <div class=" text-gray-600">
                                                    {{ member.phone }}
                                                </div>
                                            </div>
                                            <span class="px-2 py-0.5 rounded text-[10px] font-bold ml-2">{{
                                                member.grade }}</span>
                                        </div>
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                        </div>
                        <div class="flex justify-between items-center gap-4">
                            <!-- <input type="text" pInputText class="w-full md:w-40 2xl:w-56" (input)="updateMember($event)"
                                [ngModel]="member()?.hP_NO"] [placeholder]="'BOOKGSTR0010' | translate"> -->
                            <div class="relative" (clickOutside)="showPhoneDropdown.set(false)">
                                <input type="text" [ngModel]="prepaySearchPhone()" pInputText
                                    (input)="onPhoneInputSearch($event)" (ngModelChange)="onPhoneSearchInput($event)"
                                    (focus)="
                    prepaySearchPhone() &&
                      onPhoneSearchInput(prepaySearchPhone())
                  " class="border border-gray-300 px-3 py-1.5 rounded  bg-white w-full md:w-40 2xl:w-56"
                                    [placeholder]="'BOOKGSTR0010' | translate" />
                                @if (showPhoneDropdown() && filteredMembersPhone().length > 0) {
                                <div
                                    class="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto z-50 min-w-[300px]">
                                    @for (member of filteredMembersPhone(); track member.id) {
                                    <div (click)="selectMemberFromPhoneDropdown(member)"
                                        class="px-3 py-2 hover:bg-indigo-50 cursor-pointer border-b  last:border-b-0">
                                        <div class="flex justify-between items-center">
                                            <div>
                                                <div class="font-bold  text-gray-900">
                                                    {{ member.name }}
                                                </div>
                                                <div class=" text-gray-600">
                                                    {{ member.phone }}
                                                </div>
                                            </div>
                                            <span class="px-2 py-0.5 rounded text-[10px] font-bold ml-2">{{
                                                member.grade }}</span>
                                        </div>
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-end gap-4">
                        <button (click)="cancelUpdate()"
                            [class]="isEdit ? 'opacity-1' : 'opacity-0 pointer-events-none'"
                            class="p-2 bg-gray-600 hover:bg-gray-700 text-white  font-bold rounded transition-colors text-ellipsis w-[100px]">{{
                            'RECPTSTR0017' | translate }}</button>
                        <button (click)="openMemberSearch.set(true)"
                            class="p-2 bg-gray-600 hover:bg-gray-700 text-white  font-bold rounded transition-colors text-ellipsis w-[100px]">{{
                            'BOOKGSTR0004' | translate }}</button>
                        <button (click)="search()"
                            class="p-2 bg-gray-600 hover:bg-gray-700 text-white  font-bold rounded transition-colors text-ellipsis w-[100px]">{{
                            'BOOKGSTR0005' | translate }}</button>
                        <button (click)="reservation()"
                            class="p-2 bg-gray-600 hover:bg-gray-700 text-white  font-bold rounded transition-colors text-ellipsis w-[100px]">{{
                            'BOOKGSTR0006' | translate }}</button>
                    </div>
                </div>
            </div>

            <!-- 3-Column Content -->
            <div class="flex-1 flex p-2 gap-2 w-full" style="height: calc(100% - 209px);">
                <div class="grid grid-cols-12 gap-2 w-full h-full">
                    <!-- Col 1: Time -->
                    <div class="col-span-3 min-h-0">
                        <div
                            class="w-full h-full flex-shrink-0 bg-white border border-gray-200 rounded-lg p-4 flex flex-col">
                            <h3 class="font-bold text-gray-700 border-b border-gray-200 pb-3 mb-3 ">{{
                                'BOOKGSTR0011' | translate }}</h3>
                            <div class="grid grid-cols-2 gap-2 overflow-y-auto">
                                @for (time of timeSlots; track time; let i = $index) {
                                @let isEditSlot = isEdit && slotTimeEdit === time.slot_time;
                                <button (click)="selectTime(time)"
                                    [disabled]="(time.enable == 'N' || time.iS_RESERVATION === 'Y') && !isEditSlot"
                                    class="w-full py-2.5 rounded font-semibold border transition-colors"
                                    [class.bg-gray-600]="selectedTime() === time.slot_time && (time.enable === 'Y' || isEditSlot) && (time.iS_RESERVATION === 'N' || isEditSlot)"
                                    [class.text-white]="selectedTime() === time.slot_time && (time.enable === 'Y' || isEditSlot) &&  (time.iS_RESERVATION === 'N' || isEditSlot)"
                                    [class.border-gray-600]="selectedTime() === time.slot_time && (time.enable === 'Y' || isEditSlot) &&  (time.iS_RESERVATION === 'N' || isEditSlot)"
                                    [class.bg-white]="selectedTime() !== time.slot_time && time.enable === 'Y' && time.iS_RESERVATION === 'N'"
                                    [class.border-gray-300]="selectedTime() !== time.slot_time && time.enable === 'Y'  && time.iS_RESERVATION === 'N'"
                                    [class.bg-gray-100]="time.enable === 'N' && time.iS_RESERVATION == 'N'"
                                    [class.text-gray-300]="time.enable === 'N' && time.iS_RESERVATION == 'N'"
                                    [class.bg-blue-200]="time.iS_RESERVATION === 'Y' && !isEditSlot"
                                    [class.text-gray-600]="time.iS_RESERVATION === 'Y' && !isEditSlot"
                                    [class.bg-gray-500]="time.iS_RESERVATION === 'Y' && isEditSlot && selectedTime() !== time.slot_time"
                                    [class.text-gray-300]="time.iS_RESERVATION === 'Y' && isEditSlot && selectedTime() !== time.slot_time">

                                    {{ time.slot_time?.split(':').slice(0,2).join(':') }}

                                </button>
                                }
                            </div>
                        </div>
                    </div>
                    <!-- Col 2: Services -->
                    <div [ngClass]="cart().length === 0 ? 'col-span-9' : 'col-span-6'" class=" min-h-0">
                        @if(isLoading()){
                        <div class="h-full flex items-center justify-center flex-col gap-4 w-full">
                            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="animate-spin text-gray-400">
                                <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                            </svg>
                            <!-- <p class=" font-medium animate-pulse">Loading...</p> -->
                        </div>
                        }
                        @else {
                        @if(posTabs()?.length > 0){
                        <div
                            class="w-full h-full flex-1 flex flex-col bg-white border border-gray-200 rounded-lg overflow-hidden">
                            <div class="flex-shrink-0 flex border-b border-gray-200 overflow-x-auto">
                                @for (cate of posTabs(); track cate.l_CLASS_CD) {
                                <button (click)="selectCategory(cate)"
                                    class="flex-1 p-2 h-[50px] transition-all whitespace-nowrap border-y border-r  border-gray-300"
                                    [class.bg-gray-600]="selectedCategory().code === cate.l_CLASS_CD"
                                    [class.text-white]="selectedCategory().code === cate.l_CLASS_CD"
                                    [class.shadow]="selectedCategory().code === cate.l_CLASS_CD"
                                    [class.bg-transparent]="selectedCategory().code !== cate.l_CLASS_CD"
                                    [class.hover:bg-gray-100]="selectedCategory().code !== cate.l_CLASS_CD">
                                    {{ cate.l_CLASS_NM }}
                                </button>
                                }
                            </div>
                            <div class="flex flex-shrink-0 whitespace-nowrap  overflow-x-auto">
                                @for (g of currentGroups(); track g.s_CLASS_CD) {
                                <button (click)="selectGroup(g)"
                                    class="flex-1 h-[40px] border-t-0 border-b transition-all whitespace-nowrap border-y border-r border-gray-300"
                                    [class.bg-gray-600]="selectedGroup().code === g.s_CLASS_CD"
                                    [class.text-white]="selectedGroup().code === g.s_CLASS_CD"
                                    [class.shadow-inner]="selectedGroup().code === g.s_CLASS_CD"
                                    [class.bg-white]="selectedGroup().code !== g.s_CLASS_CD">
                                    <span class="pl-2 pr-2 w-full">{{ g?.s_CLASS_NM | translate }}</span>
                                </button>
                                }
                                <!-- @for (g of currentGroups(); track g) {
                                    <button (click)="selectGroup(g)"
                                        class="flex-1 p-2 h-[40px] transition-all whitespace-nowrap border-y border-r  border-gray-300"
                                        [class.bg-gray-600]="selectedGroup().code === g.s_CLASS_CD"
                                        [class.text-white]="selectedGroup().code === g.s_CLASS_CD"
                                        [class.shadow]="selectedGroup().code === g.s_CLASS_CD"
                                        [class.bg-transparent]="selectedGroup().g !== g.s_CLASS_CD"
                                        [class.hover:bg-gray-100]="selectedGroup().code !== g.s_CLASS_CD">
                                        {{ g.s_CLASS_NM }}
                                    </button>
                                    } -->

                            </div>
                            <div class="flex-1 overflow-y-auto p-2 bg-gray-50/50 ">
                                <div class="grid grid-cols-2 gap-3">
                                    @for (p of displayProducts(); track p.servicE_CD) {
                                    <button (click)="addToCart(p)"
                                        class="flex flex-col bg-white border border-gray-200 rounded-lg text-left shadow-sm hover:border-indigo-500 hover:shadow-md transition-all group active:scale-[0.98] overflow-hidden">
                                        <div class="flex flex-col">
                                            <div class="flex justify-end p-2">
                                                <span class="font-extrabold text-gray-900 text-base">
                                                    {{ p.price | currency:'':'':'1.0-0' }} {{'USERMAG0048' |
                                                    translate}}
                                                </span>
                                            </div>
                                            <div style="background-color: #dbe9f5;">
                                                <div class="p-2">
                                                    <div class="fw-500 mb-0.5 tracking-wide text-ellipsis w-full">
                                                        {{ selectedCategory().name }}
                                                    </div>
                                                    <div class="fw-500 mb-0.5 tracking-wide text-ellipsis w-full">
                                                        {{selectedGroup().name }}
                                                    </div>
                                                    <div class="fw-500 mb-0.5 tracking-wide text-ellipsis w-full"> {{
                                                        p.servicE_NM }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </button>
                                    }
                                </div>
                            </div>
                        </div>
                        }
                        @else{
                        <div class="h-64 flex flex-col items-center justify-center text-gray-400">
                            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="mb-4 opacity-20">
                                <circle cx="11" cy="11" r="8" />
                                <path d="m21 21-4.3-4.3" />
                            </svg>
                            <p class="text-lg font-medium">{{'SYSMESER0004' | translate}}</p>
                        </div>
                        }
                        }
                    </div>

                    @if(cart().length > 0){
                    <div class="col-span-3 min-h-0">
                        <!-- Col 3: Cart -->
                        <div
                            class="w-full h-full flex flex-col bg-[#EFEBE5] flex-shrink-0 border border-gray-200 rounded-lg">
                            <div
                                class="p-3 bg-[#D8D1C7] text-gray-800 h-[50px] font-bold shadow-sm rounded-t-lg flex items-center w-full relative">

                                <div class="absolute left-1/2 -translate-x-1/2">
                                    {{ 'BOOKGSTR0012' | translate }}
                                </div>

                                <div class="ml-auto">
                                    <i class="pi pi-refresh cursor-pointer fs-14" (click)="cart.set([])"></i>
                                </div>

                            </div>
                            <div class="flex-1 min-h-0 overflow-y-auto">
                                @if (cart().length === 0) {
                                <div class="h-full flex items-center justify-center   p-4 text-center"><svg
                                        xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" class="mb-4 opacity-50">
                                        <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
                                        <path d="M3 6h18" />
                                        <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg></div>
                                } @else {
                                <div class="space-y-2 p-2">
                                    @for (item of cart(); track item.servicE_CD) {
                                    <div
                                        class="bg-white/70 p-2.5 h-full rounded-lg shadow-sm border border-gray-200/80 flex flex-col gap-2 relative group overflow-auto">
                                        <div class="flex justify-between items-start">
                                            <div class="flex-1 min-w-0 pr-8">
                                                <div class="font-bold leading-tight">{{ item.servicE_NM
                                                    }}
                                                </div>
                                                <div class="mt-0.5">{{ item.l_ClassName }}
                                                    ~ {{
                                                    item.s_ClassName }}
                                                </div>
                                                <div class="mt-1">{{ (item.price *
                                                    item.quantity) | currency:'':'':'1.0-0' }} 원</div>
                                            </div>
                                            <button (click)="removeFromCart(item)"
                                                class="absolute top-2 right-2 w-7 h-7 flex-shrink-0 flex items-center justify-center text-gray-400 hover:text-white hover:bg-red-500 rounded-md transition-all">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                    <path d="M3 6h18" />
                                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
                                                    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                                </svg>
                                            </button>
                                        </div>
                                        <div class="flex items-center justify-end">
                                            <button (click)="updateQuantity(item, -1)"
                                                class="w-7 h-7 rounded-full border border-gray-300 bg-white flex items-center justify-center text-gray-600 hover:bg-gray-100 transition-colors">-</button>
                                            <div class="cart-qty">
                                                <p-inputnumber inputId="integeronly" [min]="0" [max]="99"
                                                    [(ngModel)]="item.quantity"
                                                    (ngModelChange)="updateQuantityInput(item, $event)"
                                                    styleClass="w-14 text-red-500 h-[20px] border-none"
                                                    inputStyleClass="border-none h-full fs-14 w-full text-center" />
                                            </div>
                                            <button (click)="updateQuantity(item, 1)"
                                                [class]="item.quantity < 99 ? 'opacity-1' : 'opacity-0 pointer-events-none'"
                                                class="w-7 h-7 rounded-full border border-gray-300 bg-white flex items-center justify-center text-gray-600 hover:bg-gray-100 transition-colors">+</button>
                                        </div>
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                            <div class="bg-gray-700 text-white p-4 rounded-b-lg sticky bottom-0 z-10">
                                <div class="flex justify-between items-center">
                                    <span class="font-bold ">{{ 'BOOKGSTR0013' | translate }}</span>
                                    <span class="font-bold text-xl">{{ totalWorkTime() }}<span
                                            class=" font-normal ml-1">{{
                                            'SYSMESER0019' | translate }}</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
        } @else {
        <div class="flex-1 flex flex-col bg-white border-gray-200 overflow-hidden h-full">
            <!-- Search Toolbar -->
            <div class="p-3 bg-white flex flex-col border-b border-gray-200 gap-4">
                <div class="flex justify-between gap-4">
                    <div class="flex justify-start gap-4">
                        <div class="flex gap-4 items-center">
                            <p-datepicker [(ngModel)]="param.START_DT" [iconDisplay]="'input'" [showIcon]="true"
                                (ngModelChange)="onStartDateChange()" inputId="icondisplay"
                                class="w-full md:w-40 2xl:w-56" dateFormat="yy-mm-dd" [locale]="locale"
                                inputStyleClass="w-full md:w-40 2xl:w-56" readonlyInput="true" />
                            <span>-</span>
                            <p-datepicker [(ngModel)]="param.END_DT" [iconDisplay]="'input'" [showIcon]="true"
                                (ngModelChange)="onEndDateChange()" inputId="icondisplay"
                                class="w-full md:w-40 2xl:w-56" dateFormat="yy-mm-dd"
                                inputStyleClass="w-full md:w-40 2xl:w-56" readonlyInput="true" [locale]="locale" />
                        </div>
                        <div class="flex">
                            <p-selectButton [options]="statuses" [(ngModel)]="selectedStatus" [multiple]="true"
                                optionValue="comM_D_CD" optionLabel="comM_D_NM" (onChange)="getHistory(); isNextPage.set(false)"
                                [className]="'flex flex-wrap p-0 w-full text-ellipsis gap-2'" />
                        </div>
                    </div>
                    <div class="flex justify-end gap-4">
                        <button (click)="reset()"
                            class="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white w-[100px] h-[37px] font-bold rounded transition-colors">{{
                            'REVERSTR0008' | translate }}</button>
                        <button (click)="getHistory(); isNextPage.set(false)"
                            class="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white w-[100px] h-[37px] font-bold rounded transition-colors">{{
                            'REVERSTR0009' | translate }}</button>
                        <button (click)="onShowConfirmUpdate()"
                            [class]="selectedHistoryRows()?.length <= 0 ? 'pointer-events-none bg-gray-400' : ' bg-gray-600'"
                            class="px-6 py-2  hover:bg-gray-700 text-white  font-bold w-[100px] h-[37px] rounded transition-colors">{{
                            'REVERSTR0010' | translate }}</button>
                    </div>
                </div>
                <div class="flex justify-start gap-4">
                    <div class="flex justify-between items-center gap-4">
                        <p-select [options]="staffList" [showClear]="!!param.P_USER_ID_2"
                            [(ngModel)]="param.P_USER_ID_2" [placeholder]="'REVERSTR0004' | translate"
                            optionLabel="useR_NM" optionValue="useR_ID" class="w-full md:w-40 2xl:w-56" filter="true"
                            filterBy="useR_NM" />
                    </div>
                    <span class="opacity-0">-</span>
                    <div class="flex justify-between items-center gap-4">
                        <p-select [options]="posTabs()" [showClear]="!!param.P_LCLASS_CD"
                            [(ngModel)]="param.P_LCLASS_CD" [placeholder]="'REVERSTR0005' | translate"
                            optionLabel="l_CLASS_NM" optionValue="l_CLASS_CD" class="w-full md:w-40 2xl:w-56"
                            filter="true" filterBy="l_CLASS_NM" />
                    </div>

                    <div class="flex justify-between items-center gap-4">
                        <p-select [options]="levels" [showClear]="!!param.P_MEMBER_TP" [(ngModel)]="param.P_MEMBER_TP"
                            [placeholder]="'REVERSTR0006' | translate" optionLabel="membeR_TP_NM"
                            optionValue="membeR_TP" class="w-full md:w-40 2xl:w-56" filter="true"
                            filterBy="membeR_TP_NM" />
                    </div>
                    <div class="flex justify-between items-center gap-4">
                        <input type="text" pInputText class="w-full md:w-40 2xl:w-56" (keydown.enter)="getHistory(); isNextPage.set(false)"
                            [(ngModel)]="param.P_HP_NO" (input)="onPhoneInputSearch($event)"
                            [placeholder]="'REVERSTR0007' | translate">
                    </div>
                </div>
            </div>
            <!-- Data Table Container -->
            <div class="flex-1 p-4 bg-gray-50 overflow-hidden flex flex-col">
                <app-material-table class="h-full min-h-0" [headers]="historyHeaders()" [data]="reservationHistory()"
                    [rowTemplate]="historyRowTpl" [enablePagination]="true" [pageSize]="P_PAGEROW" [totalCnt]="totalCntHistory()"
                    [allSelected]="allHistorySelected()" [key]="'no'" [width]="'w-full'" (nextPage)="nextPage($event)" [isNextPage]="isNextPage()"
                    (toggleSelectAll)="toggleSelectAllHistory()" [isPaging]="true"></app-material-table>

                <ng-template #historyRowTpl let-item>
                    <tr class="hover:bg-indigo-50/50 transition-colors h-11 cursor-pointer text-center"
                        [class.bg-indigo-50]="selectedHistoryRows().includes(item.no)"
                        (click)="toggleHistoryRow(item.no)">
                        <td class="border-r border-b"> {{ item.no }}</td>
                        <td class="border-r border-b text-center px-4">
                            {{ item.reservatioN_DT | slice:0:4 }}-{{ item.reservatioN_DT | slice:4:6 }}-{{
                            item.reservatioN_DT | slice:6:8 }}
                            {{ item.reservatioN_START | slice:0:2 }}:{{ item.reservatioN_START | slice:2:4 }}
                        </td>
                        <td class="border-r border-b text-left p-[0.4rem]">{{ item.servicE_NM }}</td>
                        <td class="border-r border-b text-right  p-[0.4rem]">
                            {{ item.salE_UPRC | number}}
                        </td>
                        <td class="border-r border-b text-left p-[0.4rem]">{{ item.membeR_NM }}</td>
                        <td class="border-r border-b text-left p-[0.4rem]">{{ item.hP_NO | phoneFormat}}</td>
                        <td class="border-r border-b text-center p-[0.4rem]">{{ item.membeR_TP_NM }}</td>
                        <!-- <td class="border-r border-b">{{ item.savE_CHARGE_AMT |number}}</td> -->
                        <td class="border-r border-b text-left p-[0.4rem]">{{ item.emP_NM }}</td>
                        <td class="border-r border-b">
                            @if(selectedHistoryRows().includes(item.no) && (['0','1'].includes(item.reservatioN_FG) ||
                            item.temp == true)){
                            <div (click)="$event.stopPropagation()">
                                <p-select [options]="statusesUpdate" [(ngModel)]="item.reservatioN_FG"
                                    optionLabel="comM_D_NM" optionValue="comM_D_CD" class="w-full" filter="true"
                                    appendTo="body" filterBy="comM_D_NM"
                                    (ngModelChange)="onStatusChange($event, item)" />
                            </div>
                            }
                            @else{
                            {{ item.reservatioN_FG_NM }}
                            }
                        </td>
                        <td class="border-r border-b" (click)="$event.stopPropagation()">
                            <p-splitbutton #sb [label]="'...' | translate" [model]="item.actions" appendTo="body"
                                (onDropdownClick)="onOpenMenu(sb)" />
                            <!-- <div class="flex gap-4 justify-center">
                                <button (click)="openReserDetail(item)"><i class="pi pi-eye"></i></button>
                                @if(item.membeR_NO)
                                {
                                <button (click)="openMemberDetails(item.membeR_NO)"> <i class="pi pi-user"></i></button>
                                }
                                @if(item.reservatioN_FG == '0')
                                {
                                <button (click)="bindDetail(item)"><i class="pi pi-pencil"></i></button>
                                }
                                @if(['0','1'].includes(item.reservatioN_FG)){
                                <button (click)="payment(item)"><i class="pi pi-credit-card"></i></button>
                                }
                            </div> -->
                        </td>
                    </tr>
                </ng-template>
            </div>
        </div>
        }
    </div>
</div>

<div *ngIf="openMemberSearch()">
    <components-member-search [open]="openMemberSearch()" (close)="openMemberSearch.set(false)"
        (memberSearch)="onSelectMemberSearch($event)"></components-member-search>
</div>

<div *ngIf="openMemberDetail()">
    <components-member-detail [open]="openMemberDetail()" [member_no]="member_noDetail"
        (close)="openMemberDetail.set(false)"></components-member-detail>
</div>

<div *ngIf="openReservationDetail()">
    <components-reservation-detail [open]="openReservationDetail()" [reservation]="reservationDetail"
        (close)="openReservationDetail.set(false)"></components-reservation-detail>
</div>

<app-pop-up-common [showConfirm]="showConfirmUpdate()" (confirmEvent)="updateStatus()"
    (cancelEvent)="showConfirmUpdate.set(false)" [message]="'REVERSTR0069'"></app-pop-up-common>

<!-- Payment Method Selector -->
@if (showPaymentMethodSelector()) {
<app-payment-method-selector [amount]="selectedHistoryRows()?.salE_UPRC" [title]="'PAYMENT'" [enablePoints]="true"
    (paymentCompleted)="onPaymentCompleted($event)"
    (cancelled)="showPaymentMethodSelector.set(false)"></app-payment-method-selector>
}